import CreateNewAds from "./selectStep/CreateNewAds";

const SelectStep = () => {
  return <CreateNewAds />;
};

export default SelectStep;
